import React from 'react';
export default class data extends React.Component {
    state ={
        data1 : "",
        
    }
    addData = data => {
        switch (data.target.name) {
            case "data1": this.setState({data1:data.target.value});break;
        
            default:
                break;
        }
    }

    render() {
        return (
            <div class={this.props.CustomerData.showResults === "0" ? '':"CustomerHidden" }>
                <div class="container" align="center">
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มลูกค้าหลัก : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="data1" value={this.state.data1} onChange={this.addData}  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> มิติลูกค้าที่ 1 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>

                    <div class='col-sm-4' style={{float: 'right'}} align="left">
                        <div class='Using input-group group-custom'>
                            <span class=""> การใช้งาน </span>
                            <div class="input-group ">
                                <span class="input-group-addon"> การใช้งาน : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                            <div class="input-group ">
                                <span class="input-group-addon"> เหตุผล : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                            <div class="input-group ">
                                <span class="input-group-addon"> ลงวันที่ : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>

                    </div>

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มลูกค้าย่อย 1 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>       

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> มิติลูกค้าที่ 2 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มลูกค้าย่อย 2 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> มิติลูกค้าที่ 3 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มลูกค้าย่อย 3 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> มิติลูกค้าที่ 4 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon">กลุ่มลูกค้าย่อย 4 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name=""  />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>                    
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> มิติลูกค้าที่ 5 : </span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
      
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> ที่อยู่ : </span>
                            <textarea style={{resize:'none'}} rows="3"  id="id1" type="text" class="form-control input-custom" name="F_Note"  onChange=""/>
                        </div>
                    </div>

                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> การส่งมอบลูกค้า :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> เขตการขาย :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> ในเครื่องบริษัท :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> ชื่อเรียก :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-4 '>  
                        <div class="input-group group-custom">
                            <span class="input-group-addon"> กลุ่มสมาชิก :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> e-mail :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>
                    <div class='col-sm-8 '>  
                        <div class="input-group group-custom-remark2">
                            <span class="input-group-addon"> Website :</span>
                            <input id="id1" type="text" class="form-control input-custom" name="" />
                            <span class="input-group-addon textIcon"></span> 
                        </div>
                    </div>



                </div>





            </div>
        )
    }
}




/*                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">กลุ่มลูกค้าหลัก : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="data1" value={this.state.data1} onChange={this.addData}  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 1 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 7 :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">กลุ่มลูกค้าย่อย 1 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 2 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 8 :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">กลุ่มลูกค้าย่อย 2 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 3 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                    </div>  

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">กลุ่มลูกค้าย่อย 3 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 4 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> รับประกันตัวแทน :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> วัน </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">กลุ่มลูกค้าย่อย 4 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> มิติลูกค้าที่ 5 : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> รับประกันบริษัทฯ :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> วัน </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                        การใช้งาน
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> Serial Number : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> %อากรเริ่มต้น : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">การใช้งาน : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> ประเภทต้นทุน : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> กลุ่ม Rebete :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> วัน </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">เหตผล : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> การคำนวฯภาษี : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> การขายติดลบ :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon">ลงวันที่ : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> ประเภทลูกค้า : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> ประเภทบริการ :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> กลุ่มราคา : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> รหัสสูตรผลิต : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> Minimum Stock :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> กลุ่มผู้ใช้ : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> สะสมแต้มสมาชิก : </span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"></span> 
                            </div>
                        </div>
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> SafetyStock :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> วัน </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-8 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> ชื่อสำหรับค้นหา : </span>
                                <input id="id1" type="text" class="form-control input-custom" name=""  />
                                <span class="input-group-addon textIcon"></span>
                            </div>
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> LeadTime :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> วัน </span> 
                            </div>
                        </div>
                    </div>

                    <div class='row cs-order-book'>
                        <div class='col-sm-8 '>  
                        </div>                    
                        <div class='col-sm-4 '>  
                            <div class="input-group group-custom">
                                <span class="input-group-addon"> %ที่รับเกิน PO ได้ :</span>
                                <input id="id1" type="text" class="form-control input-custom" name="" />
                                <span class="input-group-addon textIcon"> </span> 
                            </div>
                        </div>
                    </div>
                     */